import {
  GET_SELLER,
  GET_SELLER_SUCCESS,
  GET_SELLER_FAILURE,
  GET_SELLER_BY_ID,
  GET_SELLER_BY_ID_SUCCESS,
  GET_SELLER_BY_ID_FAILURE,
  REMOVE_SELLER,
  GET_SELLER_CATEGORIES,
  GET_SELLER_CATEGORIES_SUCCESS,
  GET_SELLER_CATEGORIES_FAILURE,
  GET_SELLER_BY_URL_KEY,
  GET_SELLER_BY_URL_KEY_SUCCESS,
  GET_SELLER_BY_URL_KEY_FAILURE,
} from "@store/sellers/constants";

import { makeApiCall } from "@lib/api/helpers";
import {
  getSellersApi,
  getSellerByIdApi,
  getSellerCategoriesApi,
  getSellerByUrlKeyApi,
  getSellerReviewsSummaryApi,
} from "@lib/api";

export const getSellers = (sellersIds) => (dispatch, getState) => {
  return makeApiCall({
    actions: {
      action: GET_SELLER,
      success: GET_SELLER_SUCCESS,
      fail: GET_SELLER_FAILURE,
    },

    dispatch,
    getState,
    spinner: false,
    alert: false,

    apiCall: getSellersApi,
    apiArgs: [sellersIds],

    formatResponse: (response) => response.data.sellers,
    returnResponse: true,
  });
};

export const getSellerById = (seller_id) => (dispatch, getState) => {
  return makeApiCall({
    actions: {
      action: GET_SELLER_BY_ID,
      success: GET_SELLER_BY_ID_SUCCESS,
      fail: GET_SELLER_BY_ID_FAILURE,
    },

    dispatch,
    getState,
    spinner: false,
    alert: false,

    apiCall: getSellerByIdApi,
    apiArgs: [seller_id],

    formatResponse: (response) => response.data.seller,
    returnResponse: true,
  });
};

export const getSellerByUrlKey = (url_key) => (dispatch, getState) => {
  return makeApiCall({
    actions: {
      action: GET_SELLER_BY_URL_KEY,
      success: GET_SELLER_BY_URL_KEY_SUCCESS,
      fail: GET_SELLER_BY_URL_KEY_FAILURE,
    },

    dispatch,
    getState,
    spinner: false,
    alert: false,

    apiCall: getSellerByUrlKeyApi,
    apiArgs: [url_key],

    formatResponse: (response) => response.data.sellers[0],
    returnResponse: true,
  });
};

export const getSellerCategories = (seller_id) => (dispatch, getState) => {
  return makeApiCall({
    actions: {
      action: GET_SELLER_CATEGORIES,
      success: GET_SELLER_CATEGORIES_SUCCESS,
      fail: GET_SELLER_CATEGORIES_FAILURE,
    },

    dispatch,
    getState,
    spinner: false,
    alert: false,

    apiCall: getSellerCategoriesApi,
    apiArgs: [seller_id],
    formatResponse: (response) => response.data.categories,
    returnResponse: true,
  });
};

export const removeSeller = (sellerId) => ({
  type: REMOVE_SELLER,
  payload: sellerId,
});

export const getSellerReviewsSummary = (seller_id) => (dispatch) => {
  return makeApiCall({
    dispatch,
    apiCall: getSellerReviewsSummaryApi,
    apiArgs: [seller_id],
    formatResponse: (response) => response.data,
    returnResponse: true,
  });
};
